import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ContactFunctionService {
  constructor(private helper: Helper, private http: HttpClient) {
  }


  public getContactFunctions(gridData = new HttpParams()) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/contact-function/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
